export enum PageCodes {
  Home = 'home',
  Blocks = 'blocks',
  ContractPackage = 'contract_package',
  Contract = 'contract',
  Account = 'account',
  ValidatorDetails = 'validator_details',
}

export const AdZoneIdMap = {
  [PageCodes.Home]: {
    banner: {
      desktop: {
        mainnet: '13',
        testnet: '10',
        integration: '10',
        stg: '7',
        dev: '5',
      },
      tablet: {
        mainnet: '14',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      mobile: {
        mainnet: '13',
        testnet: '10',
        integration: '10',
        stg: '7',
        dev: '5',
      },
    },
    textAd: {
      mainnet: '15',
      testnet: '12',
      integration: '12',
      stg: '9',
      dev: '4',
    },
  },
  [PageCodes.Blocks]: {
    banner: {
      desktop: {
        mainnet: '20',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      tablet: {
        mainnet: '20',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      mobile: {
        mainnet: '23',
        testnet: '10',
        integration: '10',
        stg: '7',
        dev: '5',
      },
    },
  },
  [PageCodes.ContractPackage]: {
    banner: {
      desktop: {
        mainnet: '20',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      tablet: {
        mainnet: '20',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      mobile: {
        mainnet: '23',
        testnet: '10',
        integration: '10',
        stg: '7',
        dev: '5',
      },
    },
  },
  [PageCodes.Contract]: {
    banner: {
      desktop: {
        mainnet: '20',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      tablet: {
        mainnet: '20',
        testnet: '11',
        integration: '11',
        stg: '8',
        dev: '6',
      },
      mobile: {
        mainnet: '23',
        testnet: '10',
        integration: '10',
        stg: '7',
        dev: '5',
      },
    },
  },
  [PageCodes.Account]: {
    banner: {
      desktop: {
        mainnet: '21',
        testnet: '16',
        integration: '16',
        stg: '8',
        dev: '6',
      },
      tablet: {
        mainnet: '21',
        testnet: '16',
        integration: '16',
        stg: '8',
        dev: '6',
      },
      mobile: {
        mainnet: '23',
        testnet: '18',
        integration: '18',
        stg: '7',
        dev: '5',
      },
    },
  },
  [PageCodes.ValidatorDetails]: {
    banner: {
      desktop: {
        mainnet: '22',
        testnet: '17',
        integration: '17',
        stg: '8',
        dev: '6',
      },
      tablet: {
        mainnet: '22',
        testnet: '17',
        integration: '17',
        stg: '8',
        dev: '6',
      },
      mobile: {
        mainnet: '25',
        testnet: '19',
        integration: '19',
        stg: '7',
        dev: '5',
      },
    },
  },
};
